import { twMerge } from 'tailwind-merge';

type LinkProps = React.ComponentPropsWithoutRef<'a'>;

export const Link = ({ target = '_blank', className, ...props }: LinkProps) => {
  return (
    <a
      target={target}
      className={twMerge('text-link underline', className)}
      {...props}
    />
  );
};
